module.exports = __webpack_public_path__ + "img/Cb.d49b4168.png";